$breakpoints: (xl, lg, md, sm, xs, xxs);

.signet-header-container {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  max-width: 100%;
  font-size: 16px;
  background-color: var(--solid-background-header);
  color: var(--primary-main);
  min-height: 10%;

  &.fixed {
    &-top {
      position: fixed;
      top: 0;
      z-index: 250;
      width: 100%;
    }

    &-bottom {
      position: fixed;
      bottom: 0;
      z-index: 200;
    }
  }

  .header-branding {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 40px;
  }

  .header-toggler {
    line-height: 1;
    display: none;
    background-color: transparent;
    margin-left: auto;
    margin-right: 8px;
    padding: 4px;
    box-shadow: none;
  }

  .header-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-basis: auto;
    width: 100%;
    max-width: 100%;

    .header-row {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      padding-right: 80px;

      .header-group {
        display: flex;
        align-items: center;

        &.align {
          &-left {
            margin-right: auto;
            margin-left: 80px;
          }

          &-center {
            margin: 0 auto;
          }

          &-right {
            margin-left: auto;
          }
        }
      }

      .header-item {
        font-weight: 600;
        margin: 8px 0;

        &.active {
          > * {
            text-decoration: underline;
            font-weight: 900;
          }
        }

        > * {
          font-weight: 600;
          white-space: nowrap;
          text-decoration: none;
        }

        &:last-child {
          border: none;
        }
      }
    }
  }

  &.collapse {
    @each $key, $value in $breakpoints {
      &-#{$key} {
        @media screen and ($key) {
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;

          .header-toggler {
            display: inline-flex;
          }

          .header-content {
            display: block;
            visibility: hidden;
            max-height: 0;
            flex-basis: 100%;
            flex-grow: 1;
            align-items: center;
            flex-direction: column;
            transform: translateY(-0.5rem);
            overflow-y: hidden;
            transition: all 0.3s ease-in-out;

            .header-row {
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;

              .header-group {
                flex-direction: column;
                justify-content: start;
                align-items: flex-start;
                width: 100%;
                margin-right: 0;
                margin-left: 0;
              }

              .header-item {
                width: 100%;
                text-align: left;
                border: none;

                > * {
                  display: block;
                  width: 100%;
                }
              }
            }
          }

          [aria-expanded='true'] + .header-content {
            height: auto;
            visibility: visible;
            margin-top: 8px;
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
  }
}
